import { IconSvg } from '../../types'

export const CoffeeIcon: IconSvg = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.33301 12.6667C1.33301 12.2985 1.63148 12 1.99967 12H11.333C11.7012 12 11.9997 12.2985 11.9997 12.6667V12.6667C11.9997 13.0349 11.7012 13.3333 11.333 13.3333H1.99967C1.63148 13.3333 1.33301 13.0349 1.33301 12.6667V12.6667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66634 2.66666C1.92996 2.66666 1.33301 3.26361 1.33301 3.99999V5.33332C1.33301 8.27884 3.72082 10.6667 6.66634 10.6667C8.3506 10.6667 9.85251 9.88594 10.8299 8.66666H12.333C13.6217 8.66666 14.6663 7.62199 14.6663 6.33332C14.6663 5.04466 13.6217 3.99999 12.333 3.99999H11.9997C11.9997 3.26361 11.4027 2.66666 10.6663 2.66666H2.66634ZM11.9997 5.33332C11.9997 6.04059 11.862 6.7157 11.612 7.33332H12.333C12.8853 7.33332 13.333 6.88561 13.333 6.33332C13.333 5.78104 12.8853 5.33332 12.333 5.33332H11.9997Z"
        fill="currentColor"
      />
    </svg>
  )
}
